<template v-cloak>
  <div class="filter-container">
    <el-container v-if="active === 0" class="custom-container">
      <el-aside class="custom-container__aside" width="200px">
        <ul>
          <li v-for="(item, index) in leftArr" :class="leftActiceIndex === index?'cur':''" :key="item">
            <a>
              {{ item }}
              <img :src="index === leftActiceIndex?successImg:successImgDefault" alt="">
            </a>
          </li>
        </ul>
      </el-aside>
      <el-main class="custom-container__main">
        <el-steps :active="active" finish-status="success" align-center style="margin-bottom: 15px;">
          <el-step title="创建/编辑场地"/>
          <el-step title="添加/编辑设备"/>
        </el-steps>
        <el-form ref="detail" :rules="rules" :model="detail" label-position="left">
          <el-row v-if="leftActiceIndex === 0" :gutter="20">
            <div class="filter-container FormTitle" style="margin-bottom:20px;">
              <!-- <span v-if="status">创建场地</span>
          <span v-if="!status">编辑场地</span> -->

            </div>
            <el-col :span="12">
              <el-form-item :label="$t(`table.fieldName`)" class="mb-50" label-width="120px" prop="FieldInfo.FieldName">
                <el-input
                  v-model="detail.FieldInfo.FieldName"
                  type="text"
                  maxlength="20"
                  placeholder="请输入场地名称(20字以内)"
                />
              </el-form-item>
              <el-form-item :label="$t(`table.fieldAddress`)" class="mb-50" label-width="120px" prop="FieldInfo.Address">
                <el-input
                  id="suggestId"
                  v-model="detail.FieldInfo.Address"
                  type="text"
                  placeholder="请输入场地地址(11字以内)"
                  @change="closeChange"
                />
              </el-form-item>
              <el-form-item :label="`经度`" label-width="120px" class="mb-50" prop="FieldInfo.Longitude">
                <el-input
                  v-model="detail.FieldInfo.Longitude"
                  type="text"
                  maxlength="50"
                  placeholder="请输入场地经度"
                />
              </el-form-item>
              <el-form-item :label="`纬度`" label-width="120px" class="mb-50" prop="FieldInfo.Latitude">
                <el-input
                  v-model="detail.FieldInfo.Latitude"
                  type="text"
                  maxlength="50"
                  placeholder="请输入场地纬度"
                />
              </el-form-item>
              <el-form-item :label="`营业时间`" label-width="120px" class="mb-50" prop="FieldInfo.OpeningTime">
                <el-input v-model="detail.FieldInfo.OpeningTime" placeholder="请输入营业时间"/>
              </el-form-item>
              <el-form-item :label="`中途开门`" label-width="120px" class="mb-50" prop="FieldInfo.AllowMidWayOpen">
                <el-radio-group v-model="detail.FieldInfo.AllowMidWayOpen">
                  <el-radio-button :label="0">允许</el-radio-button>
                  <el-radio-button :label="1">不允许</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="detail.FieldInfo.AllowMidWayOpen == 0" :label="`最大开门次数`" label-width="120px" class="mb-50" prop="FieldInfo.MaxOpenCount">
                <el-input v-model="detail.FieldInfo.MaxOpenCount" placeholder="请输入"/>
              </el-form-item>

              <!-- <el-form-item :label="$t(`table.DetailAdress`)" prop="FieldInfo.newstitle">
            <el-input v-model="detail.FieldInfo.MonthlyDiscount" type="number" maxlength="50" placeholder="请输入包月折扣" />
          </el-form-item>-->
            </el-col>
            <el-col :span="12">
              <div id="bmap"/>
            </el-col>

          </el-row>
          <el-row :gutter="20">
            <!-- 其他设置 -->
            <el-col v-if="leftActiceIndex === 1" :span="18">
              <el-col :sm="8" :xl="8">
                <el-form-item :label="`场地管理员1`" class="mb-50" label-width="120px">
                  <div class="flex">
                    <el-select v-model="detail.FieldInfo.UserId" class="custom-select w-100" filterable placeholder="请选择">
                      <el-option
                        v-for="item in manage"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                        <span style="float: left">{{ item.UserName }}</span>
                        <span v-if="item.UserId" style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleEditMaintainer(item)">编辑</span>
                      </el-option>
                    </el-select>
                    <el-button style="margin-left:10px" circle icon="el-icon-plus" type="primary" @click="handleAddUser(3)"/>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xl="8">
                <el-form-item :label="`场地维护人员1`" class="mb-50" label-width="120px">
                  <div class="flex">
                    <el-select v-model="detail.FieldInfo.DefendId" class="w-100" filterable placeholder="请选择">
                      <el-option
                        v-for="item in maintainer"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                        <span style="float: left">{{ item.UserName }}</span>
                        <span v-if="item.UserId" style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleEditMaintainer(item)">编辑</span>
                      </el-option>
                    </el-select>
                    <el-button style="margin-left: 10px" circle icon="el-icon-plus" type="primary" @click="handleAddUser(5)"/>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xl="8">
                <el-form-item :label="`场地业务员`" class="mb-50" label-width="120px">
                  <div class="flex">
                    <el-select v-model="detail.FieldInfo.SalesId" class="w-100" filterable placeholder="请选择">
                      <el-option
                        v-for="item in sales"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                        <span style="float: left">{{ item.UserName }}</span>
                        <span v-if="item.UserId" style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleEditMaintainer(item)">编辑</span>
                      </el-option>
                    </el-select>
                    <el-button style="margin-left: 10px" circle icon="el-icon-plus" type="primary" @click="handleAddUser(17)"/>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xl="8">
                <el-form-item :label="`押金场地方分润`" class="mb-50" label-width="130px" prop="FieldInfo.FieldProportion">
                  <el-input
                    v-model="detail.FieldInfo.FieldProportion"
                    step="1"
                    type="number"
                    placeholder="押金场地方分润 0-100"
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xl="8">
                <el-form-item :label="`押金代理商分润`" class="mb-50" label-width="130px" prop="FieldInfo.AgentProportion">
                  <el-input
                    v-model="detail.FieldInfo.AgentProportion"
                    step="1"
                    type="number"
                    placeholder="押金代理商分润 0-100"
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xl="8">
                <el-form-item :label="`押金业务员分润`" class="mb-50" label-width="130px" prop="FieldInfo.SalesProportion">
                  <el-input
                    v-model="detail.FieldInfo.SalesProportion"
                    step="1"
                    type="number"
                    placeholder="押金业务员分润 0-100"
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="12" :xl="12">
                <el-form-item :label="`收费分润比例`" class="mb-50" label-width="130px" prop="FieldInfo.PricePicUrl">
                  <el-input
                    v-model="detail.FieldInfo.PricePicUrl"
                    step="0.1"
                    type="number"
                    placeholder="收费分润 0-1"
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="12" :xl="12">
                <el-form-item :label="`订单分成比例`" class="mb-50" label-width="130px" prop="FieldInfo.FenChengProportion">
                  <el-input
                    v-model="detail.FieldInfo.FenChengProportion"
                    step="5"
                    type="number"
                    placeholder="收费分润 0-100"
                  />
                </el-form-item>
              </el-col>
              <!-- 是否有押金模式 -->
              <!-- <template v-if="detail.FieldInfo.ChargingMode !== 'Month'"> -->
              <el-col :span="24">
                <el-form-item
                  :label="`是否有押金`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.IsDeposit"
                >
                  <el-select v-model="detail.FieldInfo.IsDeposit" class="w-100" placeholder="请选择" @change="handleIsDeposit">
                    <el-option
                      v-for="item in IsDeposit"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="detail.FieldInfo.IsDeposit === 'Y'" :span="24">
                <el-form-item
                  :label="`押金(元)`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.Deposit"
                >
                  <el-input
                    v-model="detail.FieldInfo.Deposit"
                    type="number"
                    maxlength="50"
                    placeholder="请填写押金大于0"
                  />
                </el-form-item>
              </el-col>
              <!-- </template> -->

              <el-col :span="24">
                <el-form-item
                  :label="`自动清理`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.IsAutoClear"
                >
                  <el-select v-model="detail.FieldInfo.IsAutoClear" class="w-100" placeholder="请选择" @change="handleIsAutoClear">
                    <el-option
                      v-for="item in IsAutoClear"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="detail.FieldInfo.IsAutoClear === 'Y'" :span="24">
                <el-form-item
                  :label="`自动清理类型`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.AutoClearType"
                >
                  <el-select v-model="detail.FieldInfo.AutoClearType" class="w-100" placeholder="请选择">
                    <el-option
                      v-for="item in autoClearType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="detail.FieldInfo.IsAutoClear === 'Y' && detail.FieldInfo.AutoClearType === 0" :span="24">
                <el-form-item
                  :label="`自动清理时间`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.AutoClearTime"
                >
                  <el-input
                    v-model="detail.FieldInfo.AutoClearTime"
                    type="number"
                    maxlength="50"
                    placeholder="请填写时间 0-23 （H）"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="detail.FieldInfo.IsAutoClear === 'Y'" :span="24">
                <el-form-item
                  :label="`间隔天数`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.IntervalDay"
                >
                  <el-input
                    v-model="detail.FieldInfo.IntervalDay"
                    type="number"
                    maxlength="50"
                    placeholder="请填写间隔天数"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="`商户号`"
                  class="mb-50"
                  label-width="120px"
                  prop="FieldInfo.MaId"
                >
                  <el-select v-model="detail.FieldInfo.MaId" filterable="" clearable="">
                    <el-option v-for="(item,index) in machList" :key="`mach-${index}`" :value="item.MaId" :label="item.MachName"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="`提现自动到账`"
                  class="mb-50"
                  label-width="150px"
                  prop="FieldInfo.ReturnConinProbability"
                >
                  <el-radio-group v-model="detail.FieldInfo.ReturnConinProbability">
                    <el-radio-button :label="1">允许</el-radio-button>
                    <el-radio-button :label="0">不允许</el-radio-button>
                    <el-radio-button :label="2">单独审核</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>

            </el-col>
            <!-- 收费模式 -->
            <el-col v-if="leftActiceIndex === 2" :span="16">
              <el-row :gutter="20">
                <el-col>
                  <el-col :span="24">
                    <el-form-item :label="`收费模式`" class="mb-50" label-width="120px" prop="FieldInfo.ChargingMode">
                      <el-select v-model="detail.FieldInfo.ChargingMode" class="w-100" placeholder="请选择">
                        <el-option
                          v-for="item in chargingMode"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="detail.FieldInfo.ChargingMode !== 'Frequency' && detail.FieldInfo.ChargingMode !== 'Month' && detail.FieldInfo.ChargingMode !== 'DurationStage' && detail.FieldInfo.ChargingMode !== 'Free'" :span="24">
                    <el-form-item :label="`时长模式`" class="mb-50" label-width="120px" prop="FieldInfo.DurationType">
                      <el-select v-model="detail.FieldInfo.DurationType" class="w-100" placeholder="请选择">
                        <el-option
                          v-for="item in durationType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>

                </el-col>

              </el-row>
              <el-col v-if="detail.FieldInfo.ChargingMode !== 'Free'" :span="24">
                <el-row :gutter="20">
                  <el-col v-if="detail.FieldInfo.ChargingMode !== 'Frequency' && detail.FieldInfo.ChargingMode !== 'Month' && detail.FieldInfo.ChargingMode !== 'DurationStage'" :span="24">
                    <el-form-item :label="detail.FieldInfo.DurationType === 'two'?'前X小时':'每X小时'" class="mb-50" label-width="120px" prop="FieldInfo.Hour">
                      <!-- <el-select v-model="detail.FieldInfo.Hour" placeholder="请选择">
                    <el-option
                      v-for="item in durationType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select> -->
                      <el-input v-model="detail.FieldInfo.Hour" placeholder="请输入小时">
                        <span slot="suffix">小时</span>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="detail.FieldInfo.DurationType === 'two' && detail.FieldInfo.ChargingMode !== 'Frequency' && detail.FieldInfo.ChargingMode !== 'Month' && detail.FieldInfo.ChargingMode !== 'DurationStage'" :span="24">
                    <el-form-item :label="`前X小时是否免费`" class="mb-50" label-width="120px" prop="FieldInfo.IsFree">
                      <el-select v-model="detail.FieldInfo.IsFree" class="w-100" placeholder="请选择" @change="handleChange(detail.FieldInfo.IsFree)">
                        <el-option
                          v-for="item in isFreeOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col v-if="detail.FieldInfo.ChargingMode === 'Frequency'" :span="24">
                <el-form-item :label="`滞留最大时长`" class="mb-50" label-width="120px" prop="FieldInfo.Detention">
                  <el-input
                    v-model="detail.FieldInfo.Detention"
                    type="number"
                    maxlength="10"
                    placeholder="请输入时长大于0"
                  />
                </el-form-item>
              </el-col>

            </el-col>
          </el-row>

          <el-row v-if="leftActiceIndex === 2" :gutter="20">
            <template v-if="detail.FieldInfo.IsFree != 1">
              <el-col v-if="detail.FieldInfo.DurationType === 'two' && detail.FieldInfo.ChargingMode !== 'Month' && detail.FieldInfo.ChargingMode !== 'Frequency' && detail.FieldInfo.ChargingMode !== 'DurationStage' && detail.FieldInfo.ChargingMode !== 'Free'" :span="6" class="custom-el-col">
                <!-- <el-form-item :label="`前X小时大箱子价格Y元`" prop="FieldInfo.BigPrice01">
                  <el-input
                    v-model="detail.FieldInfo.BigPrice01"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <el-form-item :label="`前X小时中箱子价格Y元`" prop="FieldInfo.MidPrice01">
                  <el-input
                    v-model="detail.FieldInfo.MidPrice01"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
                <el-form-item :label="`前X小时箱子价格Y元`" prop="FieldInfo.SmallPrice01">
                  <el-input
                    v-model="detail.FieldInfo.SmallPrice01"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <!-- <el-form-item :label="`前X小时超大箱子价格Y元`" prop="FieldInfo.SuperBigPrice01">
                  <el-input
                    v-model="detail.FieldInfo.SuperBigPrice01"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
              </el-col>

            </template>
            <el-col v-if="detail.FieldInfo.ChargingMode !== 'DurationStage' && detail.FieldInfo.ChargingMode !== 'Free'" :span="6" class="custom-el-col">
              <template v-if="detail.FieldInfo.ChargingMode === 'Duration' && detail.FieldInfo.DurationType === 'two'">
                <!-- <el-form-item :label="`大箱子价格Z元`" prop="FieldInfo.BigPrice">
                  <el-input
                    v-model="detail.FieldInfo.BigPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <el-form-item :label="`中箱子价格Z元`" prop="FieldInfo.MidPrice">
                  <el-input
                    v-model="detail.FieldInfo.MidPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
                <el-form-item :label="`箱子价格Z元`" prop="FieldInfo.SmallPrice">
                  <el-input
                    v-model="detail.FieldInfo.SmallPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <!-- <el-form-item :label="`超大箱子价格Z元`" prop="FieldInfo.SuperBigPrice">
                  <el-input
                    v-model="detail.FieldInfo.SuperBigPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
              <!-- <el-form-item :label="`箱子价格Z元`" prop="FieldInfo.MidPrice">
                <el-input
                  v-model="detail.FieldInfo.MidPrice"
                  type="number"
                  maxlength="10"
                  placeholder="请输入价格大于0"
                />
              </el-form-item> -->
              </template>
              <template v-else-if="detail.FieldInfo.ChargingMode === 'Duration' && detail.FieldInfo.DurationType === 'one'">
                <!-- <el-form-item :label="`大箱子价格Y元`" prop="FieldInfo.BigPrice">
                  <el-input
                    v-model="detail.FieldInfo.BigPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <el-form-item :label="`中箱子价格Y元`" prop="FieldInfo.MidPrice">
                  <el-input
                    v-model="detail.FieldInfo.MidPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
                <el-form-item :label="`箱子价格Y元`" prop="FieldInfo.SmallPrice">
                  <el-input
                    v-model="detail.FieldInfo.SmallPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <!-- <el-form-item :label="`超大箱子价格Y元`" prop="FieldInfo.SuperBigPrice">
                  <el-input
                    v-model="detail.FieldInfo.SuperBigPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
              </template>
              <template v-else>
                <!-- <el-form-item :label="`大箱子价格`" prop="FieldInfo.BigPrice">
                  <el-input
                    v-model="detail.FieldInfo.BigPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <el-form-item :label="`中箱子价格`" prop="FieldInfo.MidPrice">
                  <el-input
                    v-model="detail.FieldInfo.MidPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
                <el-form-item :label="`箱子价格`" prop="FieldInfo.SmallPrice">
                  <el-input
                    v-model="detail.FieldInfo.SmallPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item>
                <!-- <el-form-item :label="`超大箱子价格`" prop="FieldInfo.SuperBigPrice">
                  <el-input
                    v-model="detail.FieldInfo.SuperBigPrice"
                    type="number"
                    maxlength="10"
                    placeholder="请输入价格"
                  />
                </el-form-item> -->
              </template>

            </el-col>
            <el-col v-if="detail.FieldInfo.ChargingMode !== 'Frequency' && detail.FieldInfo.ChargingMode !== 'Month' && detail.FieldInfo.ChargingMode !== 'DurationStage' && detail.FieldInfo.ChargingMode !== 'Free'" :span="6" class="custom-el-col">
              <!-- <el-form-item :label="`大箱子封顶价格`" prop="FieldInfo.BigCappingPrice">
                <el-input
                  v-model="detail.FieldInfo.BigCappingPrice"
                  type="number"
                  maxlength="10"
                  placeholder="请输入价格"
                />
              </el-form-item>
              <el-form-item :label="`中箱子封顶价格`" prop="FieldInfo.MidCappingPrice">
                <el-input
                  v-model="detail.FieldInfo.MidCappingPrice"
                  type="number"
                  maxlength="10"
                  placeholder="请输入价格"
                />
              </el-form-item> -->
              <el-form-item :label="`箱子封顶价格`" prop="FieldInfo.SmallCappingPrice">
                <el-input
                  v-model="detail.FieldInfo.SmallCappingPrice"
                  type="number"
                  maxlength="10"
                  placeholder="请输入价格"
                />
              </el-form-item>
              <!-- <el-form-item :label="`超大箱子封顶价格`" prop="FieldInfo.SuperBigCappingPrice">
                <el-input
                  v-model="detail.FieldInfo.SuperBigCappingPrice"
                  type="number"
                  maxlength="10"
                  placeholder="请输入价格"
                />
              </el-form-item> -->
            </el-col>
            <!-- 次数 + 区间时长 -->
            <!-- 小箱子 -->
            <el-col v-if="detail.FieldInfo.ChargingMode === 'DurationStage'" :span="8">
              <el-tooltip class="item" effect="dark" content="如果是最后一个结束时间请填写 1440" placement="top">
                <el-button size="small" type="primary" @click="handleAddStage('SmallStagePriceJson')"> <i class="el-icon-plus" /> 添加箱子区间和价格</el-button>
              </el-tooltip>
              <div v-for="(item, index) in detail.FieldInfo.SmallStagePriceJson" :key="index">
                <el-col :span="7">
                  <el-form-item :label="`开始时间(分钟)`" :rules="rules.FieldInfo.S" :prop="`FieldInfo.SmallStagePriceJson[${index}].S`">
                    <el-input
                      v-model="item.S"
                      disabled
                      type="number"
                      maxlength="10"
                      placeholder="请输入开始时间（分钟）"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="7">
                  <el-form-item :rules="rules.FieldInfo.E" :prop="`FieldInfo.SmallStagePriceJson[${index}].E`">
                    <template slot="label">
                      <span>结束时间(分钟)</span>
                    </template>
                    <el-input
                      v-model="item.E"
                      type="number"
                      maxlength="10"
                      placeholder="请输入结束时间（分钟）"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :label="`价格(元)`" :rules="rules.FieldInfo.P" :prop="`FieldInfo.SmallStagePriceJson[${index}].P`">
                    <el-input
                      v-model="item.P"
                      type="number"
                      maxlength="10"
                      placeholder="请输入价格大于等于0"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <br>
                  <br>
                  <el-button v-if="index === detail.FieldInfo.SmallStagePriceJson.length - 1" type="danger" icon="el-icon-delete" @click="handleStageDelete('SmallStagePriceJson',index)"/>
                </el-col>
              </div>

            </el-col>
            <!-- 中箱子 -->
            <!-- 大箱子 -->
            <!-- 超大箱子 -->

          </el-row>

          <div style="text-align: center; margin-top: 20px;border-top: solid 1px #eee; padding-top: 30px;">
            <el-button v-if="leftActiceIndex === 0" class="filter-item" round type="info" @click="cancel">{{ $t('table.cancel') }}</el-button>
            <el-button v-else class="filter-item" type="danger" round @click="leftActiceIndex-=1">上一步</el-button>
            <template>
              <el-button
                round
                class="filter-item"
                type="primary"
                @click="submit('detail', leftActiceIndex)"
              >下一步</el-button>
            </template>
          </div>
        </el-form>
        <!-- 添加用户弹窗 -->
        <el-drawer
          ref="drawer"
          :before-close="handleClose"
          :visible.sync="dialog"
          title="添加用户"
          direction="rtl"
          custom-class="demo-drawer"
        >
          <div class="demo-drawer__content">
            <el-form ref="form" :model="form" :rules="rulesForm">
              <el-form-item label="登录账号" label-width="100px" prop="LoginNo">
                <el-input v-model="form.LoginNo" placeholder="请输入登录账号"/>
              </el-form-item>
              <el-form-item v-if="userFlag" label="密码" label-width="100px" prop="Password">
                <el-input v-model="form.Password" type="password" placeholder="请输入密码"/>
              </el-form-item>
              <el-form-item label="用户名" label-width="100px" prop="UserName">
                <el-input v-model="form.UserName" placeholder="请输入用户名"/>
              </el-form-item>
              <el-form-item label="手机号" label-width="100px" prop="TelPhone">
                <el-input v-model="form.TelPhone" placeholder="请输入手机号"/>
              </el-form-item>
              <el-form-item label="状态" label-width="100px" prop="StatusNo">
                <el-select v-model="form.StatusNo" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="demo-drawer__footer">
              <el-button @click="cancelForm">取 消</el-button>
              <!-- <el-button :loading="loading" type="primary" @click="$refs.drawer.closeDrawer()">{{ '确 定' }}</el-button> -->
              <el-button type="primary" @click="handleConfirm">{{ '确 定' }}</el-button>
            </div>
          </div>
        </el-drawer>
      </el-main>
    </el-container>
    <template v-if="active === 1">
      <div @click="cancel">
        <el-link type="primary">
          <i class="el-icon-back"/>
          | 返回场地列表
        </el-link>

      </div>
      <device :fieldid="filedid"/>
    </template>
  </div>
</template>

<script>

import { qryDefend, txField } from '@/api/field'
import { qryUser, addUser, modUser } from '@/api/user'
import { qryMachInfo } from '@/views/shopManage/api'
import device from './components/device'
import BaiduMap from '../../../static/map.js'
import md5 from 'js-md5'
import waves from '@/directive/waves' // 水波纹指令
// import { BASE_API } from '../../../config/dev.env'
export default {
  name: 'AddNews',
  components: {
    device
  },
  directives: {
    waves
  },
  props: {
    detail: {
      type: Object,
      default: function() {
        return {}
      }
    },
    status: {
      type: Boolean,
      default: null
    }
  },
  data() {
    var validateAgentProportion = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入代理'))
      } else {
        if (value >= 0 && value <= 100) {
          callback()
        } else {
          callback(new Error('范围在 0-100 之间'))
        }
      }
    }
    var validateSalesProportion = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入代理'))
      } else {
        if (value >= 0 && value <= 100) {
          callback()
        } else {
          callback(new Error('范围在 0-100 之间'))
        }
      }
    }
    var validateFieldProportion = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入当地方'))
      } else {
        if (value >= 0 && value <= 100) {
          callback()
        } else {
          callback(new Error('范围在 0-100 之间'))
        }
      }
    }
    var validateFieldPrice = (rule, value, callback) => {
      console.log(value)
      if (value === '') {
        callback(new Error('请输入价格'))
      } else {
        if (value < 0) {
          callback(new Error('价格大于0'))
        } else {
          if (/^[0-9]*\.?[0-9]{1,2}$/.test(value)) {
            callback()
          } else {
            callback(new Error('保留2位小数'))
          }
        }
      }
    }
    var validateDeposit = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('押金大于0'))
      } else {
        console.log(this.detail.FieldInfo)
        if (this.detail.FieldInfo.DurationType === 'two') {
          const arr1 = [this.detail.FieldInfo.BigPrice01, this.detail.FieldInfo.MidPrice01, this.detail.FieldInfo.SmallPrice01, this.detail.FieldInfo.SuperBigPrice01]
          const priceArr1 = Array.from(new Set(arr1))
          const price1 = priceArr1.sort((a, b) => b - a)
          if (Number(value) < Number(price1[0])) {
            callback(new Error(`押金必须大于等于箱子价格 ${price1[0]}`))
          } else {
            callback()
          }
        } else {
          const arr = [this.detail.FieldInfo.BigPrice, this.detail.FieldInfo.MidPrice, this.detail.FieldInfo.SmallPrice, this.detail.FieldInfo.SuperBigPrice]
          const priceArr = Array.from(new Set(arr))
          const price = priceArr.sort((a, b) => b - a)
          if (Number(value) < Number(price[0])) {
            callback(new Error(`押金必须大于等于箱子价格 ${price[0]}`))
          } else {
            callback()
          }
        }
      }
    }
    var validateAutoClearTime = (rule, value, callback) => {
      if (value >= 0 && value < 24) {
        callback()
      } else {
        callback(new Error('时间为0-23点'))
      }
    }
    var validateHour = (rule, value, callback) => {
      if (value > 0 && value <= 24) {
        callback()
      } else {
        callback(new Error('时长为1-24点'))
      }
    }
    var validateDay = (rule, value, callback) => {
      if (this.detail.FieldInfo.AutoClearType === 1) {
        if (value > 0) {
          callback()
        } else {
          callback(new Error('天数大于0'))
        }
      } else {
        if (value >= 0) {
          callback()
        } else {
          callback(new Error('天数大于等于0'))
        }
      }
    }
    var validateRHour = (rule, value, callback) => {
      if (/^[1-9][0-9]*$/.test(value)) {
        callback()
      } else {
        callback(new Error('滞留时长大于 0'))
      }
    }
    const validateMin = (rule, value, callback) => {
      console.log(rule)
      const key = rule.field.match(/\.(.*?)\[/)[1]
      const regValue = rule.field.match(/\.(.*?)\./)[1].match(/\[(.*?)\]/)[1]
      console.log(key)
      console.log(regValue)
      if (/^[0-9]+$/.test(value)) {
        if (parseInt(this.detail.FieldInfo[key][regValue].E) > parseInt(this.detail.FieldInfo[key][regValue].S)) {
          callback()
        } else {
          callback(new Error('结束时间（分钟）必须大于开始时间（分钟）'))
        }
      } else {
        callback(new Error('分钟数必须是整数'))
      }
    }
    const validatePrice = (rule, value, callback) => {
      if (/^[0-9]\.?[0-9]*$/.test(value)) {
        callback()
      } else {
        callback('价格输入不正确, 小数点只能一位')
      }
    }
    return {
      machList: [],
      successImgDefault: require('@/assets/icon-success-default.png'),
      successImg: require('@/assets/icon-success-success.png'),
      leftArr: ['场地名称', '场地管理', '收费模式'],
      leftActiceIndex: 0,
      active: 0,
      rules: {
        FieldInfo: {
          FieldName: [{ required: true, message: '请输入场地名称', trigger: 'blur' }],
          Address: [{ required: true, message: '请输入场地地址', trigger: 'blur' }],
          Longitude: [{ required: true, message: '请输入经度', trigger: 'blur' }],
          Latitude: [{ required: true, message: '请输入纬度', trigger: 'blur' }],
          UserId: [{ required: true, message: '请选择管理员', trigger: 'blur' }],
          DefendId: [{ required: true, message: '请选择维护人员', trigger: 'blur' }],
          ChargingMode: [{ required: true, message: '请选择收费模式', trigger: 'blur' }],
          DurationType: [{ required: true, message: '请选择时长模式', trigger: 'blur' }],
          IsDeposit: [{ required: true, message: '请选择押金模式模式', trigger: 'blur' }],
          Deposit: [{ required: true, message: '请填写押金', trigger: 'blur' }, { validator: validateDeposit, trigger: 'blur' }],

          IsAutoClear: [{ required: true, message: '请选择箱子清理模式', trigger: 'blur' }],
          AutoClearTime: [{ required: true, message: '请填写清理时间', trigger: 'blur' }, { validator: validateAutoClearTime, trigger: 'blur' }],
          IntervalDay: [{ required: true, message: '请填写间隔天数', trigger: 'blur' }, { validator: validateDay, trigger: 'blur' }],

          BigPrice01: [{ validator: validateFieldPrice, trigger: 'blur' }],
          MidPrice01: [{ validator: validateFieldPrice, trigger: 'blur' }],
          SmallPrice01: [{ validator: validateFieldPrice, trigger: 'blur' }],
          SuperBigPrice01: [{ validator: validateFieldPrice, trigger: 'blur' }],
          BigPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          MidPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          SmallPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          SuperBigPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          BigCappingPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          MidCappingPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          SmallCappingPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          SuperBigCappingPrice: [{ validator: validateFieldPrice, trigger: 'blur' }],
          Detention: [{ required: true, message: '请输入时长', trigger: 'blur' }, { validator: validateRHour, trigger: 'blur' }],
          SalesProportion: [{ required: true, message: '业务员', trigger: 'blur' }, { validator: validateSalesProportion, trigger: 'blur' }],
          AgentProportion: [{ required: true, message: '代理', trigger: 'blur' }, { validator: validateAgentProportion, trigger: 'blur' }],
          FieldProportion: [{ required: true, message: '场地方', trigger: 'blur' }, { validator: validateFieldProportion, trigger: 'blur' }],
          AgentProportion1: [{ required: true, message: '代理', trigger: 'blur' }, { validator: validateAgentProportion, trigger: 'blur' }],
          FieldProportion1: [{ required: true, message: '场地方', trigger: 'blur' }, { validator: validateFieldProportion, trigger: 'blur' }],
          AgentProportion2: [{ required: true, message: '代理', trigger: 'blur' }, { validator: validateAgentProportion, trigger: 'blur' }],
          FieldProportion2: [{ required: true, message: '场地方', trigger: 'blur' }, { validator: validateFieldProportion, trigger: 'blur' }],
          AgentProportion3: [{ required: true, message: '代理', trigger: 'blur' }, { validator: validateAgentProportion, trigger: 'blur' }],
          FieldProportion3: [{ required: true, message: '场地方', trigger: 'blur' }, { validator: validateFieldProportion, trigger: 'blur' }],
          AgentProportion4: [{ required: true, message: '代理', trigger: 'blur' }, { validator: validateAgentProportion, trigger: 'blur' }],
          FieldProportion4: [{ required: true, message: '场地方', trigger: 'blur' }, { validator: validateFieldProportion, trigger: 'blur' }],
          MonthlyFee: [{ required: true, message: '请输入包月费用', trigger: 'blur' }],
          MonthlyDiscount: [{ required: true, message: '请输入包月折扣', trigger: 'blur' }],
          Hour: [{ required: true, message: '请输入时长' }, { validator: validateHour, trigger: 'blur' }],
          S: [
            { required: true, message: '请输入开始时间（分钟）', trigger: 'blur' },
            { validator: validateMin, trigger: 'blur' }
          ],
          E: [
            { required: true, message: '请输入结束时间（分钟）', trigger: 'blur' },
            { validator: validateMin, trigger: 'blur' }
          ],
          P: [
            { required: true, message: '请输入取件价格，价格大于等于0', trigger: 'blur' },
            { validator: validatePrice, trigger: 'blur' }
          ],
          ReturnConinProbability: [
            { required: false, message: '只能输入0-100的数字，最多保留2位小数', pattern: /^(\d+\.|)(\d{1,2}|100)$/ }
          ]
        }

      },
      rulesForm: {
        LoginNo: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        TelPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 1, max: 18, message: '长度在 1 到 18 个字符', trigger: 'blur' }
        ],
        StatusNo: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      form: {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      },
      options: [
        {
          label: '启用',
          value: 'A'
        },
        {
          label: '禁用',
          value: 'S'
        }
      ],
      deviceDetailForm: null,
      listQuery: {
        roleId: 3,
        pageIndex: 1,
        pageSize: 2147483647
      },
      manage: [],
      listQuerys: {
        roleId: 17,
        pageIndex: 1,
        pageSize: 2147483647
      },
      sales: [],
      dialogImageUrl: '',
      mask: false,
      dialogVisible: false,
      dialog: false,
      baseUrl: process.env.BASE_API,
      url_: process.env.BASE_API + '/api/common/uploadImg',
      autoClearType: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '超时清理'
        }
      ],
      maintainer: [],
      chargingMode: [
        {
          value: 'Duration',
          label: '时长'
        },
        {
          value: 'Frequency',
          label: '次数'
        },
        // {
        //   value: 'Month',
        //   label: '包月'
        // },
        {
          value: 'DurationStage',
          label: '区间时长'
        },
        {
          value: 'Free',
          label: '免费'
        }
      ],
      isFreeOption: [
        {
          value: 1,
          label: '免费'
        },
        {
          value: 0,
          label: '不免费'
        }
      ],
      durationType: [
        {
          value: 'two',
          label: '前X小时Y元后续一小时Z元'
        },
        {
          value: 'one',
          label: '每X小时Y元'
        }
      ],
      IsDeposit: [
        {
          value: 'Y',
          label: '有押金'
        },
        {
          value: 'N',
          label: '无押金'
        }
      ],
      IsAutoClear: [
        {
          value: 'Y',
          label: '自动清理'
        },
        {
          value: 'N',
          label: '不自动清理'
        }
      ],
      ac: null,
      Address: null,
      filedid: null, // 场地id
      userList: [], // 用户列表
      userFlag: true // true添加用户，false编辑用户
    }
  },
  created() {
    this.getFiledUserList()
    this.getFiledSalesmanList()
    this.getMaintrinerList()
    this.getMachList()

    // this.detail.FieldInfo.newAddress = null
    // setTimeout(() => {
    //   this.Address = this.detail.FieldInfo.Address
    // }, 250)
  },
  mounted() {
    this.$nextTick(function() {
      var this_ = this
      BaiduMap.init().then((BMap) => {
        const map = new BMap.Map('bmap', { enableMapClick: true })
        let marker = ''
        if (this_.detail.FieldInfo.FieldName && this_.detail.FieldInfo.Longitude !== 0 && this_.detail.FieldInfo.Latitude !== 0) {
          map.centerAndZoom(new BMap.Point(this_.detail.FieldInfo.Longitude, this_.detail.FieldInfo.Latitude), 11)
          marker = new BMap.Marker(new BMap.Point(this_.detail.FieldInfo.Longitude, this_.detail.FieldInfo.Latitude))
        } else {
          map.centerAndZoom('北京', 11)
          marker = new BMap.Marker(new BMap.Point(116.403613, 39.91513))
        }
        var top_left_navigation = new BMap.NavigationControl() // 左上角，添加默认缩放平移控件
        // this_.ac = new BMap.Autocomplete( // 建立一个自动完成的对象
        //   {
        //     'input': 'suggestId',
        //     'location': map
        //   })
        // var ac = this_.ac
        map.addControl(top_left_navigation)
        map.addOverlay(marker)
        map.enableScrollWheelZoom(true)
        var geoc = new BMap.Geocoder()
        // 点击自动完成
        // ac.addEventListener('onconfirm', e => {
        //   console.log(e)
        //   this_.Address = this_.detail.FieldInfo.Address = ''
        //   this_.Address = this_.detail.FieldInfo.Address = e.item.value.province + e.item.value.city + e.item.value.district + e.item.value.street
        //   this_.Address = this_.detail.FieldInfo.Address = this_.detail.FieldInfo.Address.substr(0, 11)
        //   geoc.getPoint(this_.detail.FieldInfo.Address, function(e) {
        //     map.clearOverlays()
        //     if (!this_.detail.FieldInfo) {
        //       this_.detail.FieldInfo = {}
        //     }
        //     this_.detail.FieldInfo.Longitude = e.lng
        //     this_.detail.FieldInfo.Latitude = e.lat
        //     marker = new BMap.Marker(new BMap.Point(this_.detail.FieldInfo.Longitude, this_.detail.FieldInfo.Latitude))
        //     map.centerAndZoom(this_.detail.FieldInfo.Address, 11)
        //     map.addOverlay(marker)
        //   })
        // })
        // ac.hide()
        map.addEventListener('click', (e) => {
          map.clearOverlays()
          if (!this.detail.FieldInfo) {
            this.detail.FieldInfo = {}
          }
          geoc.getLocation(e.point, (rs) => {
            var addComp = rs.addressComponents
            this.detail.FieldInfo.Longitude = e.point.lng
            this.detail.FieldInfo.Latitude = e.point.lat
            this.$set(this.detail.FieldInfo, 'Address', addComp.city + addComp.district + addComp.street + addComp.streetNumber)
            // this.detail.FieldInfo.Address = addComp.city + addComp.district + addComp.street + addComp.streetNumber
            // this.Address = this.detail.FieldInfo.Address = this.detail.FieldInfo.Address.substr(0, 11)
            marker = new BMap.Marker(new BMap.Point(this.detail.FieldInfo.Longitude, this.detail.FieldInfo.Latitude))
            map.addOverlay(marker)
          })
        })
      })
    })
  },
  methods: {
    // 获取商户列表
    getMachList() {
      qryMachInfo({ pageIndex: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        this.machList = res.LsList
      })
    },
    imgSuccess(data) {
      this.detail.FieldInfo.PricePicUrl = data
      console.log(data, '1184--------------')
    },
    // 获取场地方用户列表
    getFiledUserList() {
      qryUser(this.listQuery).then(response => {
        this.manage = response.LsList
        this.manage.unshift({ UserName: '请选择', UserId: null })
      })
    },
    // 获取场地方业务员列表
    getFiledSalesmanList() {
      qryUser(this.listQuerys).then(response => {
        this.sales = response.LsList
        this.sales.unshift({ UserName: '请选择', UserId: null })
      })
    },
    // 获取维护人员用户列表
    getMaintrinerList() {
      qryDefend({
        userId: this.$store.getters.roles.UserId,
        pageIndex: 1,
        pageSize: 2147483647
      }).then(response => {
      // console.log(response)
        this.maintainer = response.LsList
        this.maintainer.unshift({ UserId: 0, UserName: '请选择' })
      })
    },
    addUser() {

    },
    handleEditMaintainer(item) {
      console.log(item)
      for (const key in this.form) {
        this.form[key] = item[key]
      }
      this.userFlag = false
      this.dialog = true
    },
    // 添加用户
    handleAddUser(roleId) {
      this.userFlag = true
      this.form.RoleId = roleId
      this.dialog = true
    },
    // 关闭弹窗
    handleClose(done) {
      this.resetForm()
      done()
    },
    // 取消弹窗
    cancelForm() {
      this.dialog = false
    },
    // 弹窗确定提交
    handleConfirm() {
      console.log(this.form)
      this.form.Password = this.userFlag ? md5(this.form.Password) : this.form.Password
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.UserId) { // 修改
            modUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.$message.success('修改成功')
                this.dialog = false
                this.resetForm()
                this.getMaintrinerList()
                this.getFiledUserList()
              }
            })
          } else {
            addUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.dialog = false
                this.resetForm()
                this.getMaintrinerList()
                this.getFiledUserList()
              }
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      }
    },
    // 添加区间和价格
    handleAddStage(key) {
      const obj = {
        S: 0,
        E: null,
        P: 0
      }
      if (this.detail.FieldInfo[key].length >= 10) {
        this.$notify({
          type: 'error',
          title: '提示',
          message: '区间价格最多只能添加10个'
        })
        return
      }
      if (this.detail.FieldInfo[key].length === 0) {
        this.detail.FieldInfo[key].push(obj)
        return
      }
      this.$refs['detail'].validateField(`FieldInfo.${key}[${this.detail.FieldInfo[key].length - 1}].E`, error => {
        if (!error) {
          if (this.detail.FieldInfo[key].length !== 0) {
            obj.S = this.detail.FieldInfo[key][this.detail.FieldInfo[key].length - 1].E
          }
          this.detail.FieldInfo[key].push(obj)
        }
      })
    },
    // 删除区间价格
    handleStageDelete(key, index) {
      this.detail.FieldInfo[key].pop()
    },
    // 提交/修改
    submit(formName, index) {
      console.log(this.detail.FieldInfo.PricePicUrl)
      this.detail.FieldInfo.FieldId = this.status ? -1 : this.detail.FieldInfo.FieldId
      console.log(this.detail)
      // if (this.detail.FieldInfo.FieldName) {
      //   this.filedid = this.detail.FieldInfo.FieldId
      //   this.active = 1
      //   return
      // }
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.detail, '1305-----------------')
          if (index >= 0 && index < 2) {
            console.log(123)
            this.leftActiceIndex++
            return
          }
          if (this.detail.FieldInfo.ChargingMode === 'Duration') { // 时长收费
            this.detail.FieldInfo.SmallStagePriceJson = null
            this.detail.FieldInfo.MidStagePriceJson = null
            this.detail.FieldInfo.BigStagePriceJson = null
            this.detail.FieldInfo.SuperBigStagePriceJson = null

            if (this.detail.FieldInfo.DurationType === 'one') {
              this.detail.FieldInfo.BigPrice01 = 0
              this.detail.FieldInfo.MidPrice01 = 0
              this.detail.FieldInfo.SmallPrice01 = 0
              this.detail.FieldInfo.SuperBigPrice01 = 0
              this.detail.FieldInfo.IsFree = 0
              if (this.detail.FieldInfo.IsAutoClear === 'N') {
                this.detail.FieldInfo.AutoClearType = 0
                this.detail.FieldInfo.IntervalDay = 0
              }
              if (this.detail.FieldInfo.AutoClearType === 1) {
                this.detail.FieldInfo.AutoClearTime = 0
              }
              this.detail.FieldInfo.Detention = 0
              txField(this.detail.FieldInfo).then(response => {
                if (response > 0) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  })
                  if (this.status) {
                    this.filedid = response
                  } else {
                    this.filedid = this.detail.FieldInfo.FieldId
                  }

                  this.active = 1
                  console.log(response)
                  // qryDevice({ fieldId: this.detail.FieldInfo.FieldId }).then(request => {
                  //   console.log(1, request.length)
                  //   if (request && request.length > 0) {
                  //     request.forEach(item => {
                  //       console.log(1, item)
                  //       const boxInfo = new window.proto.SocketCmd.CmdHeader()
                  //       boxInfo.setCmdcode(0x0207)
                  //       boxInfo.setIdentity(this.$store.getters.roles.LogNo)
                  //       boxInfo.setOppositeid(item)
                  //       boxInfo.setTimetoken(new window.Date().getTime())
                  //       this.cySocket.sendMsg(boxInfo.serializeBinary())
                  //     })
                  //   }
                  // })
                  // this.$emit('backList')
                }
              })
            } else {
              if (this.detail.FieldInfo.IsFree) {
                this.detail.FieldInfo.BigPrice01 = 0
                this.detail.FieldInfo.MidPrice01 = 0
                this.detail.FieldInfo.SmallPrice01 = 0
                this.detail.FieldInfo.SuperBigPrice01 = 0
              }
              if (this.detail.FieldInfo.IsAutoClear === 'N') {
                this.detail.FieldInfo.AutoClearType = 0
                this.detail.FieldInfo.IntervalDay = 0
              }
              if (this.detail.FieldInfo.AutoClearType === 1) {
                this.detail.FieldInfo.AutoClearTime = 0
              }
              txField(this.detail.FieldInfo).then(response => {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                if (this.status) {
                  this.filedid = response
                } else {
                  this.filedid = this.detail.FieldInfo.FieldId
                }
                this.active = 1
                console.log(response)
                // qryDevice({ fieldId: this.detail.FieldInfo.FieldId }).then(request => {
                //   console.log(2, request.length)
                //   if (request && request.length > 0) {
                //     request.forEach(item => {
                //       console.log(2, item)
                //       const boxInfo = new window.proto.SocketCmd.CmdHeader()
                //       boxInfo.setCmdcode(0x0207)
                //       boxInfo.setIdentity(this.$store.getters.roles.LogNo)
                //       boxInfo.setOppositeid(item)
                //       boxInfo.setTimetoken(new window.Date().getTime())
                //       this.cySocket.sendMsg(boxInfo.serializeBinary())
                //     })
                //   }
                // })
                // this.$emit('backList')
              })
            }
          } else if (this.detail.FieldInfo.ChargingMode === 'Frequency') { // 按次收费
            this.detail.FieldInfo.DurationType = null
            this.detail.FieldInfo.Hour = 0
            this.detail.FieldInfo.IsFree = 0
            this.detail.FieldInfo.BigCappingPrice = 0
            this.detail.FieldInfo.MidCappingPrice = 0
            this.detail.FieldInfo.SmallCappingPrice = 0
            this.detail.FieldInfo.SuperBigCappingPrice = 0
            this.detail.FieldInfo.BigPrice01 = 0
            this.detail.FieldInfo.MidPrice01 = 0
            this.detail.FieldInfo.SmallPrice01 = 0
            this.detail.FieldInfo.SuperBigPrice01 = 0
            this.detail.FieldInfo.SmallStagePriceJson = null
            this.detail.FieldInfo.MidStagePriceJson = null
            this.detail.FieldInfo.BigStagePriceJson = null
            this.detail.FieldInfo.SuperBigStagePriceJson = null
            // this.detail.FieldInfo.Detention = 0
            if (this.detail.FieldInfo.IsAutoClear === 'N') {
              this.detail.FieldInfo.AutoClearType = 0
              this.detail.FieldInfo.IntervalDay = 0
            }
            if (this.detail.FieldInfo.AutoClearType === 1) {
              this.detail.FieldInfo.AutoClearTime = 0
            }
            txField(this.detail.FieldInfo).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              if (this.status) {
                this.filedid = response
              } else {
                this.filedid = this.detail.FieldInfo.FieldId
              }
              this.active = 1
              console.log(response)
            })
          } else if (this.detail.FieldInfo.ChargingMode === 'Month') { // 包月收费模式
            this.detail.FieldInfo.DurationType = null
            this.detail.FieldInfo.Hour = 0
            this.detail.FieldInfo.IsFree = 0

            this.detail.FieldInfo.BigCappingPrice = 0
            this.detail.FieldInfo.MidCappingPrice = 0
            this.detail.FieldInfo.SmallCappingPrice = 0
            this.detail.FieldInfo.SuperBigCappingPrice = 0
            this.detail.FieldInfo.BigPrice01 = 0
            this.detail.FieldInfo.MidPrice01 = 0
            this.detail.FieldInfo.SmallPrice01 = 0
            this.detail.FieldInfo.SuperBigPrice01 = 0

            this.detail.FieldInfo.Detention = 0
            // 控制是否有押金
            // this.detail.FieldInfo.IsDeposit = 'N'
            // this.detail.FieldInfo.Deposit = 0
            this.detail.FieldInfo.SmallStagePriceJson = null
            this.detail.FieldInfo.MidStagePriceJson = null
            this.detail.FieldInfo.BigStagePriceJson = null
            this.detail.FieldInfo.SuperBigStagePriceJson = null
            if (this.detail.FieldInfo.IsAutoClear === 'N') {
              this.detail.FieldInfo.AutoClearType = 0
              this.detail.FieldInfo.IntervalDay = 0
            }
            if (this.detail.FieldInfo.AutoClearType === 1) {
              this.detail.FieldInfo.AutoClearTime = 0
            }
            txField(this.detail.FieldInfo).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              if (this.status) {
                this.filedid = response
              } else {
                this.filedid = this.detail.FieldInfo.FieldId
              }
              this.active = 1
              // qryDevice({ fieldId: this.detail.FieldInfo.FieldId }).then(request => {
              //   console.log(3, request.length)
              //   if (request && request.length > 0) {
              //     request.forEach(item => {
              //       console.log(3, item)
              //       const boxInfo = new window.proto.SocketCmd.CmdHeader()
              //       boxInfo.setCmdcode(0x0207)
              //       boxInfo.setIdentity(this.$store.getters.roles.LogNo)
              //       boxInfo.setOppositeid(item)
              //       boxInfo.setTimetoken(new window.Date().getTime())
              //       this.cySocket.sendMsg(boxInfo.serializeBinary())
              //     })
              //   }
              // })
              // this.$emit('backList')
              console.log(response)
            })
          } else if (this.detail.FieldInfo.ChargingMode === 'DurationStage') { // 区间时长收费模式
            this.detail.FieldInfo.DurationType = null
            this.detail.FieldInfo.Hour = 0
            this.detail.FieldInfo.IsFree = 0
            this.detail.FieldInfo.BigCappingPrice = 0
            this.detail.FieldInfo.MidCappingPrice = 0
            this.detail.FieldInfo.SmallCappingPrice = 0
            this.detail.FieldInfo.SuperBigCappingPrice = 0
            this.detail.FieldInfo.BigPrice01 = 0
            this.detail.FieldInfo.MidPrice01 = 0
            this.detail.FieldInfo.SmallPrice01 = 0
            this.detail.FieldInfo.SuperBigPrice01 = 0
            this.detail.FieldInfo.SmallPrice = 0
            this.detail.FieldInfo.MidPrice = 0
            this.detail.FieldInfo.BigPrice = 0
            this.detail.FieldInfo.SuperBigPrice = 0

            // this.detail.FieldInfo.Detention = 0
            if (this.detail.FieldInfo.IsAutoClear === 'N') {
              this.detail.FieldInfo.AutoClearType = 0
              this.detail.FieldInfo.IntervalDay = 0
            }
            if (this.detail.FieldInfo.AutoClearType === 1) {
              this.detail.FieldInfo.AutoClearTime = 0
            }
            // const arr = ['SmallStagePriceJson', 'MidStagePriceJson', 'BigStagePriceJson', 'SuperBigStagePriceJson']
            const arr = ['SmallStagePriceJson']

            for (const item of arr) {
              if (this.detail.FieldInfo[item].length === 0) {
                this.$message.error('请添加区间和价格')
                return
              }
            }
            const SmallStagePriceJson = JSON.parse(JSON.stringify(this.detail.FieldInfo.SmallStagePriceJson))
            for (const stage of SmallStagePriceJson) {
              stage.S = Number(stage.S)
              stage.E = Number(stage.E)
              stage.P = Number(stage.P)
            }
            const MidStagePriceJson = JSON.parse(JSON.stringify(this.detail.FieldInfo.MidStagePriceJson))
            for (const stage of MidStagePriceJson) {
              stage.S = Number(stage.S)
              stage.E = Number(stage.E)
              stage.P = Number(stage.P)
            }
            const BigStagePriceJson = JSON.parse(JSON.stringify(this.detail.FieldInfo.BigStagePriceJson))
            for (const stage of BigStagePriceJson) {
              stage.S = Number(stage.S)
              stage.E = Number(stage.E)
              stage.P = Number(stage.P)
            }
            const SuperBigStagePriceJson = JSON.parse(JSON.stringify(this.detail.FieldInfo.SuperBigStagePriceJson))
            for (const stage of SuperBigStagePriceJson) {
              stage.S = Number(stage.S)
              stage.E = Number(stage.E)
              stage.P = Number(stage.P)
            }
            console.log(this.detail.FieldInfo, '1509------------------------')
            txField({
              ...this.detail.FieldInfo,
              SmallStagePriceJson: JSON.stringify(SmallStagePriceJson),
              MidStagePriceJson: JSON.stringify(MidStagePriceJson),
              BigStagePriceJson: JSON.stringify(BigStagePriceJson),
              SuperBigStagePriceJson: JSON.stringify(SuperBigStagePriceJson) }).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              if (this.status) {
                this.filedid = response
              } else {
                this.filedid = this.detail.FieldInfo.FieldId
              }
              this.active = 1
              console.log(response)
            })
          } else { // 免费模式
            this.detail.FieldInfo.DurationType = null
            this.detail.FieldInfo.Hour = 0
            this.detail.FieldInfo.IsFree = 0
            this.detail.FieldInfo.BigCappingPrice = 0
            this.detail.FieldInfo.MidCappingPrice = 0
            this.detail.FieldInfo.SmallCappingPrice = 0
            this.detail.FieldInfo.SuperBigCappingPrice = 0
            this.detail.FieldInfo.BigPrice01 = 0
            this.detail.FieldInfo.MidPrice01 = 0
            this.detail.FieldInfo.SmallPrice01 = 0
            this.detail.FieldInfo.SuperBigPrice01 = 0
            this.detail.FieldInfo.SmallPrice = 0
            this.detail.FieldInfo.MidPrice = 0
            this.detail.FieldInfo.BigPrice = 0
            this.detail.FieldInfo.SuperBigPrice = 0

            // this.detail.FieldInfo.Detention = 0
            if (this.detail.FieldInfo.IsAutoClear === 'N') {
              this.detail.FieldInfo.AutoClearType = 0
              this.detail.FieldInfo.IntervalDay = 0
            }
            if (this.detail.FieldInfo.AutoClearType === 1) {
              this.detail.FieldInfo.AutoClearTime = 0
            }
            const arr = ['SmallStagePriceJson', 'MidStagePriceJson', 'BigStagePriceJson', 'SuperBigStagePriceJson']
            // const arr = ['SmallStagePriceJson']

            for (const item of arr) {
              this.detail.FieldInfo[item] = null
            }
            console.log(this.detail.FieldInfo, '1609------------------------')
            txField({
              ...this.detail.FieldInfo }).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              if (this.status) {
                this.filedid = response
              } else {
                this.filedid = this.detail.FieldInfo.FieldId
              }
              this.active = 1
              console.log(response)
            })
          }
        }
      })
      // this.$emit('backList')
    },
    // 修改是否免费
    handleChange(value) {
      // console.log(value)
      // if (value) {
      //   this.detail.FieldInfo.BigPrice01 = 0
      //   this.detail.FieldInfo.MidPrice01 = 0
      //   this.detail.FieldInfo.SmallPrice01 = 0
      //   this.detail.FieldInfo.SuperBigPrice01 = 0
      // } else {
      //   this.detail.FieldInfo.BigPrice01 = 0.1
      //   this.detail.FieldInfo.MidPrice01 = 0.1
      //   this.detail.FieldInfo.SmallPrice01 = 0.1
      //   this.detail.FieldInfo.SuperBigPrice01 = 0.1
      // }
    },
    cancel() {
      this.$emit('backList')
    },
    handleRemove(file, fileList) {
      console.log(file)
      console.log(fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
      console.log(file.url)
    },
    // 切换是否有押金
    handleIsDeposit() {
      if (this.detail.FieldInfo.IsDeposit === 'N') {
        this.detail.FieldInfo.Deposit = 0
      }
    },
    // 切换是否自动清理
    handleIsAutoClear() {
      if (this.detail.FieldInfo.IsAutoClear === 'N') {
        this.detail.FieldInfo.AutoClearTime = 0
      }
    },
    // 删除图片
    handleDelPic() {
      this.$confirm('确定要删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detail.FieldInfo.PricePicUrl = null
        this.$message.success('图片已经清空，提交后生效')
      }).catch(() => {})
    },
    success(response, file, fileList) {
      if (response && response.ReturnCode === 200) {
        this.$message.success('图片上传成功')
        this.detail.FieldInfo.PricePicUrl = response.Data
      } else {
        this.$message.error('图片上传失败')
      }
      console.log(this.detail.FieldInfo.PricePicUrl)
    },
    closeChange() {
      BaiduMap.init().then((BMap) => {
        const map = new BMap.Map('bmap', { enableMapClick: true })
        let marker = ''
        var top_left_navigation = new BMap.NavigationControl() // 左上角，添加默认缩放平移控件
        map.addControl(top_left_navigation)
        map.enableScrollWheelZoom(true)
        var geoc = new BMap.Geocoder()
        geoc.getPoint(this.detail.FieldInfo.Address, (point) => {
          if (point) {
            map.centerAndZoom(point, 16)
            this.detail.FieldInfo.Longitude = point.lng
            this.detail.FieldInfo.Latitude = point.lat
            map.addOverlay(new BMap.Marker(point))
          } else {
            this.$message({
              type: 'error',
              message: '请填写正确的地址'
            })
          }
        }, '北京市')
        map.addEventListener('click', (e) => {
          map.clearOverlays()
          geoc.getLocation(e.point, (rs) => {
            var addComp = rs.addressComponents
            this.detail.FieldInfo.Longitude = e.point.lng
            this.detail.FieldInfo.Latitude = e.point.lat
            this.Address = this.detail.FieldInfo.Address = addComp.city + addComp.district + addComp.street + addComp.streetNumber
            // this.Address = this.detail.FieldInfo.Address = this.detail.FieldInfo.Address.substr(0, 11)
            marker = new BMap.Marker(new BMap.Point(this.detail.FieldInfo.Longitude, this.detail.FieldInfo.Latitude))
            map.addOverlay(marker)
          })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/styles/variables.scss";
.custom-el-col{
  background-color: rgba($color: $menuTextActive, $alpha: 0.07);
  border-radius: 20px;
  border: solid 1px rgba($color: $menuTextActive, $alpha: 0.44);
  padding-top: 16px;
  padding-bottom: 16px;
  margin-right: 20px;
  ::v-deep{
    .el-form-item__label{
      color: $menuTextActive;
    }
  }

}
ul{
  margin: 0;
  padding: 0;
}
li{
  list-style: none;
}
#bmap {
  width: 100%;
  height: 450px;
}
.el-form-item__label {
  float: none;
}
[v-cloak] {
  display: none;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
}
.el-upload--picture-card{
  width: 178px;
  height: 148px;
  position: relative;
}
.mask{
  position: absolute;
  top: -12px;
  left: 60px;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.5);
}
.mask .el-icon-delete{
  color: white;
  position: absolute;
  font-size: 16px;
  left: 8px;
  top: 6px;
}
/* .el-upload--picture-card{
  width: 300px;
  height: 66px;
} */
.demo-drawer__footer{
  text-align: center;
}
.demo-drawer__content{
  padding: 20px;
}
.line{
  height: 10px;
  background: #f3f3f3;
  clear: both;
}
.custom-container{
  &__aside{
    background-color: white;
    margin-right: 5px;
    ul{
      li{
        height: 88px;
        text-align: center;
        line-height: 88px;
        font-size: 18px;
        color: $b999;
        a{
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            margin-left: 30px;
          }
        }
        &.cur{
          background-color: #F5F5F5;
          color: $menuTextActive;
          font-weight: bold;
        }
      }
    }
  }
  &__main{
    background-color: white;
  }
}
</style>
